import { ReactNode } from 'react';
import styled from 'styled-components';
import { colors, spacing } from '@ardoq/design-tokens';

const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  border-top: 1px solid ${colors.borderSubtle};
  gap: ${spacing.s8};
  padding: ${spacing.s16} ${spacing.s24};
  align-items: flex-end;
`;

export interface ModalFooterProps {
  children?: ReactNode;
  className?: string;
}

const ModalFooter = ({ children, className }: ModalFooterProps) => (
  <FooterContainer className={className}>{children}</FooterContainer>
);

export { ModalFooter };
